// @ts-nocheck
import * as $ from 'jquery';

import { FormApplication } from './FormApplication';

$(() => {
    const formPageContainer = $('[data-form]');

    // If we are not on send tickets page we stop script
    if (formPageContainer.length === 0) {
        return;
    }

    $('[data-toggle="tooltip"]').tooltip();
    
    let container = $(formPageContainer[0]);
    container.data('formsApp', new FormApplication(container));
});
